import styled from '@xstyled/styled-components'

export const FormInputWrap = styled.input<{
  error: boolean
  value: boolean
  validated: boolean
}>`
  background: none;
  border: none;
  width: 100%;
  height: 32px;
  outline: none;
  ~ .label {
    ${({ value } /* eslint-disable indent */) =>
      value &&
      `
    top: -16px;
    left: 0;
    opacity: 1;
  `}
  }
  :focus ~ .label {
    top: -16px;
    left: 0;
    opacity: 1;
  }
`
